const doc = [({"en":({"js":({"admin":({"comments":({"expanded_content_partial":({"comment_log":"Comment log", "write_comment":"Write comment"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;